import { render, staticRenderFns } from "./AccusationHistory.vue?vue&type=template&id=62ffdae8&scoped=true"
import script from "./AccusationHistory.vue?vue&type=script&lang=js"
export * from "./AccusationHistory.vue?vue&type=script&lang=js"
import style0 from "./AccusationHistory.vue?vue&type=style&index=0&id=62ffdae8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ffdae8",
  null
  
)

export default component.exports